<template>
  <div id="users-list" class="users-list-container">

    <user-view-sidebar
      v-if="sidebarData.id !== undefined"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :user="sidebarData"
    />

    <user-view-sidebar
      v-else
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
    />

    <vs-table
      ref="table"
      multiple
      noDataText="Sem dados disponíveis"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="users"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
            v-if="canSee('add')"
            class="
              p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between
              text-lg font-medium text-base text-primary border border-solid border-primary
            "
            @click="addNewData"
          >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Adicionar Novo</span>
          </div>

          <div
            class="
              p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between
              text-lg font-medium text-base text-primary border border-solid border-primary
            "
            @click="modalChoiceERP = true"
            v-if="hasErpFeature"
          >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Sincronizar com ERP</span>
          </div>
        </div>


        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4"
        >
          <div
            class="
              p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
              cursor-pointer flex items-center justify-between font-medium
            "
          >
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                users.length - currentPage * itemsPerPage > 0
                ? currentPage * itemsPerPage
                : users.length
              }} of {{ queriedItems }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="email">Email</vs-th>
        <vs-th sort-key="name">Nome</vs-th>
        <vs-th sort-key="username">Usuário</vs-th>
        <vs-th sort-key="role">Permissão</vs-th>
        <vs-th sort-key="department">Departamento</vs-th>
        <vs-th sort-key="status" v-if="isAdminUser">Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="product-email font-medium truncate">{{ tr.email }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.username }}</p>
            </vs-td>

            <vs-td>
              <p class="product-username font-medium truncate">
                {{ tr.role ? tr.role.display_name : '' }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-username font-medium truncate">
                {{ tr.userDepartment ? tr.userDepartment.name : '' }}
              </p>
            </vs-td>

            <vs-td>
              <vs-chip :color="getConnectionStatusColor(tr.isConnected)" class="product-order-status">
                {{ getConnectionStatusName(tr.isConnected) | title }}
              </vs-chip>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                v-if="canSee('update')"
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />

              <feather-icon
                v-if="canSee('remove') && tr.id !== 1"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="removeUserModal(tr)"
              />

              <feather-icon
                v-if="(canSee('disconnect') || isAdminUser) && tr.isConnected"
                icon="LogOutIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                class="ml-2"
                @click.stop="logoutUserModal(tr)"
              />
              <feather-icon
                v-if="(canSee('unblock') || isAdminUser) && tr.blocked_at"
                icon="LockIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="unblockUserModal(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-popup
      title="Você realmente deseja fazer isso?"
      :active="popupActivatedUnblock"
      @close="popupActivatedUnblock = false"
    >
      <p>
        Você deseja realmente desbloquear o usuário <strong>{{ userInfos.email }}</strong>?
      </p>

      <vs-button
        color="rgb(62, 201, 214)"
        type="filled"
        class="align-right"
        @click.prevent="unblockUser()"
      >
        <span>Sim</span>
      </vs-button>
    </vs-popup>

    <vs-popup
      title="Você realmente deseja fazer isso?"
      :active.sync="popupActivated"
      class="sizePopup"
    >
      <p>
        Você deseja realmente desconectar o usuário <strong>{{ userInfos.email }}</strong>?
      </p>

      <vs-button
        color="rgb(62, 201, 214)"
        type="filled"
        class="align-right"
        @click.prevent="logoutUser()"
      >
        <span>Sim</span>
      </vs-button>
    </vs-popup>

    <vs-popup
      title="Você realmente deseja fazer isso?"
      :active.sync="removePopupActivated"
    >
      <p>
        Você deseja realmente remover o usuário <strong>{{ userInfos.email }}</strong>?
      </p>

      <vs-button
        color="rgb(62, 201, 214)"
        type="filled"
        class="align-right"
        @click.prevent="checkToRemoveUser()"
      >
        <span>Sim</span>
      </vs-button>
    </vs-popup>

    <ErpModal
      :isActive="modalChoiceERP"
      @isActiveFalse="modalChoiceERP=false"
      v-if="hasErpFeature"
      :isUsers="true"
    />

    <user-tickets-to-remove
      :active="openRemoveTicketsPopUp"
      :tickets="ticketsResearch"
      @activeFalse="openRemoveTicketsPopUp = false"
      @activeTrue="openRemoveTicketsPopUp = true"
      @openToDeleteUser="removePopupActivated = true"
    />

  </div>
</template>

<script>
  import UserViewSidebar from './UserViewSidebar'
  import { checkByUser } from '@/http/requests/chatTicket';

  import moduleUser from '@/store/user/moduleUser'
  import { hasPermission, getIp, hasFeature } from '@/utils'
  import ErpModal from '../orders/products/ErpModal.vue'

  import user from '@/http/requests/user'
  import UserTicketsToRemove from './UserTicketsToRemove.vue';

  export default {
    name: 'users-list',
    components: {
      UserViewSidebar,
      ErpModal,
      UserTicketsToRemove
    },
    data() {
      return {
        selected: [],
        popupActivated: false,
        removePopupActivated: false,
        popupActivatedUnblock: false,
        itemsPerPage: 4,
        isMounted: false,
        addNewDataSidebar: false,
        sidebarData: {},
        userInfos: {},
        hasErpFeature: false,
        modalChoiceERP: false,
        ticketsResearch: [],
        openRemoveTicketsPopUp: false
      }
    },
    computed: {
      isAdminUser() {
        let userInfo = JSON.parse(localStorage.getItem("userInfo"))
        if (userInfo && userInfo.role) {
          if (userInfo.role.name === 'administrador') {
            return true
          }
        }

        return false
      },
      currentPage() {
        if (this.isMounted) {
          const totalPages = Math.ceil(this.queriedItems / this.itemsPerPage);
          let currentPage = this.$refs.table.currentx;

          currentPage = Math.min(totalPages, Math.max(1, currentPage));

          return currentPage;
        }

        return 0;
      },
      users() {
        return this.$store.state.user.users
      },
      queriedItems() {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.users.length
      }
    },
    methods: {
      unblockUserModal(userInfos){
        this.userInfos = userInfos
        this.popupActivatedUnblock = true
      },
      unblockUser() {
        user.unblockUser(this.userInfos.id)
          .then((response) => {
            this.$vs.notify({
              color: 'success',
              title: 'Sucesso!',
              text: 'Usuário desbloqueado com sucesso.'
            })
            this.popupActivatedUnblock = false
          })
          .catch(err => { console.error(err) })
      },
      removeUserModal(userInfos) {
        this.userInfos = userInfos
        this.removePopupActivated = true
      },
      logoutUserModal(userInfos) {
        this.userInfos = userInfos
        this.popupActivated = true
      },
      async logoutUser() {
        try {
          const ip = await getIp();
          if (ip) {
            await user.disconnectUser(this.userInfos.id, ip);
          } else {
            console.error('Não foi possível obter o endereço IP.');
            return;
          }
          this.$store.dispatch("user/fetch");
          this.userInfos = {};
          this.popupActivated = false;
        } catch (error) {
          console.error('Erro ao desconectar o usuário:', error);
        }
      },
      getConnectionStatusName(activated) {
        if (activated !== false && activated !== 'false' && activated !== 0 && activated !== '0') {
          return 'Online'
        }

        return 'Offline'
      },
      getConnectionStatusColor(activated) {
        if (activated !== false && activated !== 'false' && activated !== 0 && activated !== '0') {
          return 'success'
        }

        return 'danger'
      },
      addNewData() {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      checkToRemoveUser() {

        checkByUser(this.userInfos.id)
        .then((async response => {

          this.ticketsResearch = await response.data.data.checkChatTicketsByUser
          if (this.ticketsResearch.length === 0) {
            return this.deleteUser();
          }
          
          this.removePopupActivated   = false;
          this.openRemoveTicketsPopUp = true;

        }))
        
      },
      deleteUser() {
        this.$store.dispatch("user/delete", this.userInfos.id)
        .then(() => {
          this.$vs.notify({
            color: 'success',
            title: 'Sucesso!',
            text: 'Usuário removido com sucesso.'
          })
          this.removePopupActivated = false
      })
      .catch(err => { console.error(err) })
      },
      editData(data) {
        // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
        let sideData = this.$_.cloneDeep(data)

        if (sideData.userDepartment === null) {
          sideData.userDepartment = {
            id: null,
            name: '',
            activated: false
          }
        }

        this.sidebarData = sideData

        this.toggleDataSidebar(true)
      },
      toggleDataSidebar(val=false) {
        this.addNewDataSidebar = val
      },
      canSee(action) {
        return hasPermission(`${this.$route.name}-${action}`)
      }
    },
    created() {
      if (!moduleUser.isRegistered) {
        this.$store.registerModule('user', moduleUser)
        moduleUser.isRegistered = true
      }
      this.$store.dispatch("user/fetch")
    },
    beforeRouteLeave(to, from, next) {
      if (this.addNewDataSidebar) {
        this.addNewDataSidebar = false;
        setTimeout( ()=> {
          next();
        }, 2);
      } 
      else if (this.removePopupActivated) {
        this.removePopupActivated = false;
        setTimeout( ()=> {
          next();
        }, 2);
      }
      else if (this.modalChoiceERP) {
        this.modalChoiceERP = false;
        setTimeout( ()=> {
          next();
        }, 2);
      }
      else if (this.popupActivated) {
        this.popupActivated = false
        setTimeout( ()=> {
          next();
        }, 2);
      }
      else if (this.popupActivatedUnblock) {
        this.popupActivatedUnblock = false
        setTimeout( ()=> {
          next();
        }, 2);
      }
      else if (this.openRemoveTicketsPopUp) {
        this.openRemoveTicketsPopUp = false
        setTimeout( ()=> {
          next();
        }, 2);
      }
      else {
        next();
      }
    },
    async mounted() {
      this.isMounted = true;
      this.hasErpFeature = await hasFeature('erps')
    }
  }
</script>

<style lang="scss">
  #users-list {
    .vs-con-table {

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;


        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
